// @ts-nocheck
//Smooth Scroll
import { Link } from 'react-scroll';

// レイアウト
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

// モーダル
import { useState } from 'react';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function F_fixture() {

  // モーダル
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);

  return (
    <div className="facility-lower">
      <h2 className='tag-title'>鍵</h2>
      {/* <Row className="my-4" as='dl'> */}
      {/* <Col sm={3} as='dt' className='toc-btn-title'>
          鍵
        </Col> */}
      {/* <Col sm={9} as='dd' className='mb-0'>
          <Row className='toc-btnArea'>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter04"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                鍵管理（ルール）<br />について
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter05"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                鍵紛失・複製<br />について
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter06"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                鍵のスペアを借りる
              </Link>
            </Col>
          </Row>
        </Col> */}
      {/* </Row> */}

      <section className="sec-fixtures">
        <h3 className='icon-title type-pencil'>鍵について</h3>
        <iframe src="https://docs.google.com/presentation/d/1dX2XuXKvWbRHKV-9VdL-8B766ITrfKYMQgFfGgU84xk/preview?slide=id.p" width="860" height="520" allow="autoplay"></iframe>
      </section>

      {/* <section className="sec-fixtures">
        <h3 id="chapter04" className='icon-title type-pencil'>鍵管理（ルール）について</h3>
        <div className="border-box">
          <p className="todo-catch"><span>To Do</span>デスクと引き出しの鍵はナンバリングをして管理している為、引き出しの交換を行わないでください。<br />席替えの際は人のみの移動としてください。</p>
        </div>

        <h3 id="chapter05" className='icon-title type-pencil'>鍵紛失・複製について</h3>
        <div className="border-box">
          <p className="todo-catch"><span>To Do</span>鍵紛失時のフロー</p>
          <div className="l-number-wrapper">
            <ol>
              <li>紛失された鍵については、複製を作成する必要があります。<br />※鍵の作成費用目安は、おおよそ1,500円～2,500円(税別)です。</li>
              <li>上司及び、ロケーション管理の担当者へご報告の上、まずは始末書を連絡書で申請してください。</li>
              <li>始末書を連絡書で申請後、鍵の見積を取りますので、総務へご連絡ください。</li>
              <li>見積を受け取られましたら、金額を記載して購入稟議書と給与天引きの人事稟議書を申請してください。</li>
            </ol>
            <p>
              <br />
              <a href='https://docs.google.com/document/d/1W_iotVpKlP8_-xXpxNK-WiYUSFIqE3AFXK63Wtqe8oA/edit' target='_blank'>詳細</a>は、こちらからご確認ください。
            </p>
          </div>
        </div>

        <h3 id="chapter06" className='icon-title type-pencil'>鍵のスペアを借りる</h3>
        <div className="border-box">
          <p className="todo-catch"><span>To Do</span>エビデンスを残す必要があるため、連絡書の起案をお願いいたします。
          </p>
        </div>
        <div className="img-wrap ct">
          <div className="img-title">（楽楽精算⇒①申請・承認⇒②ワークフロー⇒③連絡書⇒④連絡書）※下記画像参照</div>
          <div className="flame">
            <img
              src={process.env.PUBLIC_URL + '/facility_pic/fixture03.jpg'}
              alt="18F"
              className="img-wrap__img"
            />
          </div>
        </div>










      </section> */}


    </div >
  );
}

export default F_fixture;

